import { useState } from "react";
import "./index.scss";
import { useTranslation } from "react-i18next";

export const TechnicalSection = () => {
  const isMobile = window.innerWidth < 1000;

  const [inputStatus, setInputStatus] = useState("");

  const [sentMessage, setSentMessage] = useState("");

  const { t } = useTranslation();

  const sendEmail = () => {
    if (
      inputStatus &&
      /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(inputStatus)
    ) {
      navigator.sendBeacon(
        `https://wp5243tr2ssc3iubo3klbtbsky0aprfl.lambda-url.us-east-1.on.aws/${inputStatus}`
      );

      setSentMessage("Thank you for joining the waitlist!");
    } else {
      setSentMessage("Please enter a valid email address.");
    }

    setTimeout(() => {
      setSentMessage("");
    }, 5000);
  };

  return (
    <div className="c-technical-section">
      <h1 className="c-technical-section__title">
        {isMobile
          ? "Let’s get technical."
          : t("presentationPage.should-we-title")}
      </h1>
      <p className="c-technical-section__text">
        {t("presentationPage.should-we-desc")}
        {/* <br /> <br />
        Watugot will allow retail stores all over the world to list items in
        their local currency<sup>2</sup>. */}
      </p>
      <div className="c-technical-section__input">
        <input
          type="email"
          onChange={(e) => {
            setInputStatus(e.target.value);
          }}
          value={inputStatus}
          className="c-technical-section__input-field"
          placeholder="Your email here. We’ll keep it safe..."
        />

        <button
          className="c-technical-section__input-button"
          onClick={sendEmail}
        >
          {/* Join the waitlist */}
          {t("presentationPage.join_the")}
        </button>
      </div>
      <div>{sentMessage}</div>
      <div className="c-technical-section__footer">
        <p className="c-technical-section__footer-text">
          1. Maximum radius of 30 kilometers. <br />
          2. Expected to release in the coming months.
        </p>
      </div>
    </div>
  );
};
